export const BrandName = ({ className = "text-xl" }) => (
    <span className={`flex flex-col items-start font-display leading-none tracking-[0.12em] text-bone ${className}`}>
        <span>
            CLARKE<span className="text-gold">.</span>
        </span>
        <span className="mt-1.5 font-sans text-[9px] font-normal uppercase tracking-[0.4em] text-ash">
            Business Solutions
        </span>
    </span>
);

export const LogoMark = ({ className = "h-8 w-8" }) => (
    <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
        <defs>
            <linearGradient id="cbs-gold" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#9A7B24" />
                <stop offset="0.42" stopColor="#D4AF37" />
                <stop offset="0.68" stopColor="#F3DD8E" />
                <stop offset="1" stopColor="#B08D2A" />
            </linearGradient>
        </defs>
        <rect x="10.5" y="10.5" width="43" height="43" transform="rotate(45 32 32)" stroke="url(#cbs-gold)" strokeWidth="1.15" />
        <circle cx="32" cy="32" r="23" stroke="url(#cbs-gold)" strokeOpacity="0.35" strokeWidth="0.55" />
        <circle cx="32" cy="32" r="21.6" stroke="url(#cbs-gold)" strokeOpacity="0.18" strokeWidth="0.4" />
        <rect x="20.5" y="20.5" width="23" height="23" transform="rotate(45 32 32)" stroke="url(#cbs-gold)" strokeOpacity="0.4" strokeWidth="0.55" />
        <rect x="30.9" y="7.9" width="2.2" height="2.2" transform="rotate(45 32 9)" fill="url(#cbs-gold)" />
        <rect x="30.9" y="53.9" width="2.2" height="2.2" transform="rotate(45 32 55)" fill="url(#cbs-gold)" />
        <rect x="7.9" y="30.9" width="2.2" height="2.2" transform="rotate(45 9 32)" fill="url(#cbs-gold)" />
        <rect x="53.9" y="30.9" width="2.2" height="2.2" transform="rotate(45 55 32)" fill="url(#cbs-gold)" />
        <text x="23.5" y="41" textAnchor="middle" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="27" fontWeight="500" fill="url(#cbs-gold)">C</text>
        <text x="40.3" y="38.5" textAnchor="middle" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="11.5" fontWeight="600" letterSpacing="0.5" fill="url(#cbs-gold)">BS</text>
        <line x1="22" y1="47" x2="28.8" y2="47" stroke="url(#cbs-gold)" strokeOpacity="0.85" strokeWidth="0.6" />
        <line x1="35.2" y1="47" x2="42" y2="47" stroke="url(#cbs-gold)" strokeOpacity="0.85" strokeWidth="0.6" />
        <rect x="30.9" y="45.9" width="2.2" height="2.2" transform="rotate(45 32 47)" fill="url(#cbs-gold)" />
    </svg>
);
export const BrandLockup = ({ emblemClass = "h-16 w-16", textClass = "text-2xl", align = "center" }) => (
    <div className={`flex flex-col ${align === "center" ? "items-center text-center" : "items-start text-left"}`}>
        <LogoMark className={emblemClass} />
        <div className={`mt-3 font-display leading-none tracking-[0.12em] text-bone ${textClass}`}>
            CLARKE<span className="text-gold">.</span>
        </div>
        <div className="mt-1.5 font-sans text-[9px] font-normal uppercase tracking-[0.35em] text-ash">
            Business Solutions
        </div>
    </div>
);

